import { Predicate } from "@siteimprove/alfa-predicate";
import { hasValue } from "../../name/index.js";
import { Node } from "../../node.js";
import { hasName } from "../../node/predicate.js";
const { test } = Predicate;
export function hasAccessibleName(device, nameOrPredicate = () => true, ...names) {
    const predicate = typeof nameOrPredicate === "string"
        ? hasValue(nameOrPredicate, ...names)
        : nameOrPredicate;
    return (node) => test(hasName(predicate), Node.from(node, device));
}
//# sourceMappingURL=has-accessible-name.js.map